import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import './common.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as constants from "../../const";
import {loginforImpersonateUser,updateSidebarmenuToggle,getPDF,initilizeWorkday} from '../../actions/index';


class Sidebar extends Component {
    constructor(props){
        super(props);
        this.state = {
            showMenu:true
        };        
        this.toggleMenu = this.toggleMenu.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
    }

    updateDimensions() {
        var windowWidth = window.innerWidth;
        if(windowWidth > 767){
            this.setState({
                showMenu:true
            });
        } else {
            this.setState({
                showMenu:false
            });
        }
    }

    handleLoad(){
        var windowWidth = window.innerWidth;
        if(windowWidth > 767){
            this.setState({
                showMenu:true
            });
        } else {
            this.setState({
                showMenu:false
            });
        }
    }
    componentWillMount(){
        window.addEventListener('load', this.handleLoad);
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount(){
        window.removeEventListener('load', this.handleLoad);
        window.removeEventListener("resize", this.updateDimensions);
    }
    
    toggleMenu(){
        var menuState = this.state.showMenu;
        this.setState({
            showMenu:!menuState
        });
    }
    getUserName(){
        var empName = this.props.auth.name;
        var firstname = '', lastname='';
        if (empName != '') {            
            var splitEmpFullName = empName.split('.'),
            firstname = splitEmpFullName[0],
            lastname = splitEmpFullName[1];
            return firstname  + ' ' + lastname
        } return firstname + ' ' + lastname;
    }

    handleReset(e)
    {
        e.preventDefault();
        this.props.initilizeWorkday();
    }
    renderSidebarFooter(){
        let sidebarFooterData = this.props.workdays;
        let role = this.props.auth.role;
        const isMenumappingConf = this.props.auth.activeMenus && Array.isArray(this.props.auth.activeMenus) && this.props.auth.activeMenus.length > 0 ;
        if(sidebarFooterData && sidebarFooterData.length > 0 && role == constants.roles.EMPLOYEE_ROLE){
            let sidebarData = sidebarFooterData[0];
            return (
                <div className={"sidebarFooter " + (role == constants.roles.EMPLOYEE_ROLE && !isMenumappingConf ?'show':'hidden')}>
                    <div className="row">
                        <span className="bottom-content">Previous Time Off:</span>
                        <span className="bottom-contents">{sidebarData.wdy_previous_time_off}</span>
                    </div>
                    <div className="row">
                        <span className="bottom-content" title="Where you currently are in your 6 day cycle">Cycle 6 Day:</span>
                        <span className="bottom-contents">{sidebarData.wdy_7dayValue}</span>
                    </div>
                    <div className="row">
                        <span className="bottom-content" title="Where you currently are in your 14 day cycle">Cycle 14 Day:</span>
                        <span className="bottom-contents">{sidebarData.wdy_14dayValue}</span>
                    </div>
                </div>
            )
        } else {
            return ("")
        }
    }
    renderAdminMenu(){
        return (
        <div className={this.state.showMenu ? "menu-list adminMenu" : "hidden menu-list"} ref="sideMenu">
            <ul id="menu-content" className="menu-content collapse out">
                <li>
                    <div className="headingSidebar" onClick = {() => this.props.toggleSidebarMenu("pay")} >
                        <span className="menu-txt">Pay</span><span className = {this.props.showPayMenu ? "caret caret-up" : "caret caret-item"}></span>
                    </div>
                </li>
                <div className={this.props.showPayMenu?"" : "hidden"}> 
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/noncertified" activeClassName="selected">
                            {/* <span className="menu-icon">N</span> */}
                            <span className="menu-txt">Non Certified</span>
                        </NavLink>
                    </li>
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/certified" activeClassName="selected">
                            {/* <span className="menu-icon">C</span> */}
                            <span className="menu-txt">Certified</span>
                        </NavLink>
                    </li>
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/claims" activeClassName="selected">
                            {/* <span className="menu-icon">PC</span> */}
                            <span className="menu-txt">Pending Claims</span>
                        </NavLink>
                    </li>
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/acceptedclaims" activeClassName="selected">
                            {/* <span className="menu-icon">AC</span> */}
                            <span className="menu-txt">Accepted Claims</span>
                        </NavLink>
                    </li>
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/rejectedclaims" activeClassName="selected">
                            {/* <span className="menu-icon">RC</span> */}
                            <span className="menu-txt">Rejected Claims</span>
                        </NavLink>
                    </li> 
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/noncertifiedPre16" activeClassName="selected" >
                            {/* <span className="menu-icon">N/C</span> */}
                            <span className="menu-txt">{"Certified/Non Certified > 16 days"}</span>
                        </NavLink>
                    </li>
                    <li onClick={(e) =>this.handleReset(e)}>
                        <NavLink to="/manuallyupdate" activeClassName="selected">
                            {/* <span className="menu-icon">MU</span> */}
                            <span className="menu-txt">Manually update Hastus</span>
                        </NavLink>
                    </li>
                    
                </div>
                
                <li>
                    <div className="headingSidebar" onClick = {() => this.props.toggleSidebarMenu("log")} >
                        <span className="menu-txt">HOS</span><span className = {this.props.showLogMenu ? "caret caret-up" : "caret caret-item"}></span>
                    </div>
                </li>
                <div className={this.props.showLogMenu?"" : "hidden"}>
                    <li>
                        <NavLink to="/hoslogsworkdays" activeClassName="selected">
                            {/* <span className="menu-icon">HL</span> */}
                            <span className="menu-txt">HOS Logs</span>
                        </NavLink>
                        </li>
                        <li>
                        <NavLink to="/hoslogsc/C" activeClassName="selected"  >
                            {/* <span className="menu-icon">HL</span> */}
                            <span className="menu-txt">Certified</span>
                        </NavLink>
                        </li>
                        <li>
                        <NavLink to="/hoslogsu/U" activeClassName="selected"  >
                            {/* <span className="menu-icon">HL</span> */}
                            <span className="menu-txt">Non Certified</span>
                        </NavLink>                        
                    </li>
                </div>
                <li>
                    <div className="headingSidebar" onClick = {() => this.props.toggleSidebarMenu("others")} >
                        <span className="menu-txt">Administrative</span><span className = {this.props.showOtherMenu ? "caret caret-up" : "caret caret-item"}></span>
                    </div>
                </li>
                <div className={this.props.showOtherMenu?"" : "hidden"}>
                    <li>
                        <NavLink to="/admin" activeClassName="selected" >
                        {/* onClick={this.props.loginforImpersonateUser}> */}
                            {/* <span className="menu-icon">IU</span> */}
                            <span className="menu-txt">Impersonate User</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/configurations" activeClassName="selected">
                            {/* <span className="menu-icon">CFG</span> */}
                            <span className="menu-txt">Configurations</span>
                        </NavLink>
                    </li>
                </div>
                <li>
                    <div className="headingSidebar" onClick = {() => this.props.toggleSidebarMenu("alert")} >
                        <span className="menu-txt">Alert</span><span className = {this.props.showAlertMenu ? "caret caret-up" : "caret caret-item"}></span>
                    </div>
                </li>
                <div className={this.props.showAlertMenu?"" : "hidden"}>
                    <li>
                        <NavLink to="/outlaw" activeClassName="selected" className="hidden"> 
                            <span className="menu-txt">Alert</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/hoslogs/Greater12" activeClassName="selected" className="" >
                            <span className="menu-txt">{"HOS > 12"} </span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/series14" activeClassName="selected">
                            {/* <span className="menu-icon">S</span> */}
                            <span className="menu-txt">{"Series > 14"}</span>
                        </NavLink>
                    </li>
                </div>
                <div className="divider-sidebar"></div>
                <li>
                    <NavLink to="/series" activeClassName="selected">
                        {/* <span className="menu-icon">S</span> */}
                        <span className="menu-txt">Series</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/frareport" activeClassName="selected">
                        {/* <span className="menu-icon">FRA</span> */}
                        <span className="menu-txt">FRA Report</span>
                    </NavLink>
                </li>
               
                <li>
                    <NavLink to="/audittrail" activeClassName="selected">
                        {/* <span className="menu-icon">AT</span> */}
                        <span className="menu-txt">Audit Trail</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/hastusToTCE" activeClassName="selected" >
                        <span className="menu-txt">HASTUS TCE</span>
                    </NavLink>
                </li>
            </ul>
            {this.renderPDFMenu(true)}
        </div>
        );
    }
    renderEmployeeMenu() {
        const activeMenus = this.props.auth.activeMenus.map((m) => m.MenuType) ;
        const hosMenu = constants.Menus.find((menu) => menu.Name == "HOS");
        const seriesMenu = constants.Menus.find((menu) => menu.Name == "Series");
        let isLogmenuActive = hosMenu && Array.isArray(activeMenus) && activeMenus.length > 0 ? activeMenus.includes(hosMenu.id) : false;
        let isSeriesmenuActive = seriesMenu && Array.isArray(activeMenus) && activeMenus.length > 0 ? activeMenus.includes(seriesMenu.id) : false;
        return(
        <div className={this.state.showMenu ? "menu-list" : "hidden menu-list"} ref="sideMenu">
            <ul id="menu-content" className="menu-content collapse out">
            
                {this.props.auth.impersonateUserId > 0 &&
                <li>
                    <NavLink to="/admin" activeClassName="selected">   
                            <span className="menu-icon">I</span>                 
                            <span className="menu-txt">Impersonate User</span>
                    </NavLink>
                </li>
                
                }
                   
                
                <li>
                    <NavLink to="/workdays" activeClassName="selected">
                        <span className="menu-icon">M</span>
                        <span className="menu-txt">{activeMenus && Array.isArray(activeMenus) && activeMenus.length > 0 ? "Pay Details" : "My HOS"}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/userhoslogsworkdays" activeClassName="selected" className={isLogmenuActive ? "" : "hidden"} >
                        <span className="menu-icon">HL</span>
                        <span className="menu-txt">HOS Logs</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/series" activeClassName="selected" className={isSeriesmenuActive ? "" : "hidden"} >
                        <span className="menu-icon">S</span>
                        <span className="menu-txt">Series</span>
                    </NavLink>
                </li>
                <li className="hidden">
                    <NavLink to="/addWorkday" activeClassName="selected">
                        <span className="menu-icon">A</span>
                        <span className="menu-txt">Add Workday</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/historicalWorkdays" activeClassName="selected" className={isLogmenuActive ? "" : "hidden"} >
                        <span className="menu-icon">HL</span>
                        <span className="menu-txt">Historical Logs</span>
                    </NavLink>
                </li>

            </ul>
            {this.renderPDFMenu()}
        </div>
        );
    }

    

    renderPDFMenu(isAdmin = false) {
        return(
            <ul id="menu-content" className="menu-content collapse out">
                <li>
                    <a href='#' onClick={(e)=>this.onclickTest(e,'HoursofServiceFAQs.pdf')} >
                        <span className={isAdmin ? "hidden" : "menu-icon" }>F</span>
                        <span className="menu-txt">FAQ</span>
                    </a>
                </li>
                <li>
                    <a href='#' onClick={(e)=>this.onclickTest(e,'HOSManual.pdf')}>
                        <span className={isAdmin ? "hidden" : "menu-icon" }>U</span>
                        <span className="menu-txt">User Guide</span>
                    </a>
                </li>
            </ul>
        );
    }

    onclickTest(e,name)  {
        e.preventDefault();
        if(name){
            let path = `/pdf/${name}`;
            let fetch_url = constants.actionUrls.GET_FAQ_PDF + '/' + name
            let fetchObj = {url:fetch_url}
            this.props.getPDF(fetchObj, function(isAvail){ 
                if(!isAvail){
                    alert(`${name.includes("FAQ")?"FAQ":"User Guide"} not found`);
                    return false;
                }
                else{
                    window.open(path,"_blank");
                }
            });
        }
    }

    renderFRAMenu()
    {
        return(
            <div className={this.state.showMenu ? "menu-list" : "hidden menu-list"} ref="sideMenu">
                <ul id="menu-content" className="menu-content collapse out">
                <li>
                    <NavLink to="/frareport" activeClassName="selected">
                        <span className="menu-icon">FRA</span>
                        <span className="menu-txt">FRA Report</span>
                    </NavLink>
                </li>
                </ul>
                {this.renderPDFMenu()}
            </div>
        );

    }
    renderMenu(role)
    {     
        switch (role) {
            case constants.roles.FRA_ROLE:
                return this.renderFRAMenu();
            case constants.roles.ADMIN_ROLE:
                return this.props.auth.impersonateUserId > 0 ?this.renderEmployeeMenu():this.renderAdminMenu();                           
            default:
                return this.renderEmployeeMenu();                
        }
    }

    render() {
        let role = this.props.auth.role;
        return (
            <div className="fullHeight">
            <div className={"nav-side-menu " + (role == 'Employee' ? '' : 'fullHeight')}>
                <div className="brand">HOS 3.0<span className="headerName pull-right"> {this.getUserName()} </span>
                    <div className="toggleMenuParent">
                        <div onClick={() => this.toggleMenu()} id="toggle-menu-icon" className={this.state.showMenu ? "toggle-btn open" : "toggle-btn"}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                {this.renderMenu(role)}
            </div>            
                {this.renderSidebarFooter()}      
                <div>
                <span className="appVersion">Version: 3.11.0</span>
                </div>      
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
       auth:state.authState,
       workdays: state.workdays.workdays,
       showPayMenu : state.configurations.showPayMenu,
       showLogMenu : state.configurations.showLogMenu,
       showOtherMenu : state.configurations.showOtherMenu,
       showAlertMenu : state.configurations.showAlertMenu
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loginforImpersonateUser:loginforImpersonateUser,
            toggleSidebarMenu : updateSidebarmenuToggle,
            getPDF:getPDF,
            initilizeWorkday:initilizeWorkday

        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Sidebar);
